// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bex_a bht_bk bht_bl bht_bo","SwipeLeftToClose--animating":"bex_b"};